import { DiffEditor, type DiffEditorProps } from '@monaco-editor/react'
import { ReactElement } from 'react'

type MonacoStableDiffEditorProps = Omit<DiffEditorProps, 'keepCurrentOriginalModel' | 'keepCurrentModifiedModel'>

export default function MonacoStableDiffEditor(props: MonacoStableDiffEditorProps): ReactElement {
  return <DiffEditor {...props} keepCurrentOriginalModel keepCurrentModifiedModel />
}
